import type { DeepNonNullable } from 'utility-types';
import { deepOmitBy } from './deepOmitBy';
import { isObject } from './isObject';
import { isEmpty } from './isEmpty';

export function pruneUndefinedAndNull<T>(obj: T): DeepNonNullable<T> {
  if (Array.isArray(obj) || isObject(obj)) {
    return deepOmitBy(obj, isEmpty) as DeepNonNullable<T>;
  } else {
    throw Error('Argument must be an object or an array.');
  }
}
